<template>
  <transition name="offline-pop">
    <div
      v-if="!isOnline"
      data-test="offline-banner"
      class="offline-pill"
      role="status"
      aria-live="polite"
    >
      <svg
        class="offline-pill__icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M1 1l22 22" />
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0 1 22.58 9" />
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
        <line x1="12" y1="20" x2="12.01" y2="20" />
      </svg>
      <span>{{ t("You're offline") }}</span>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useNetworkStatus } from "@/composables/useNetworkStatus";

const { t } = useI18n();
const { isOnline } = useNetworkStatus();
</script>

<style scoped>
/* A compact, rounded "toast" pill floating just above the bottom tab bar.
   pointer-events:none so it can never block taps on the content beneath it, and
   it sits at the bottom edge instead of covering content.

   The 70px below is the tab bar's content height, hardcoded a second time here
   because `.custom-tab-bar` in `TabsPage.vue` keeps it in a scoped style with no
   shared custom property to read. Change one and you must change the other.

   The inset is read in three levels, `--ion-safe-area-bottom` first: on the
   Capacitor path Android zeroes the WebView's own env() and publishes the real
   values as custom properties, which `variables.scss` republishes. */
.offline-pill {
  position: fixed;
  left: 50%;
  bottom: calc(var(--ion-safe-area-bottom, env(safe-area-inset-bottom, 0px)) + 70px + 12px);
  transform: translateX(-50%);
  z-index: 10000;

  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: calc(100vw - 32px);
  padding: 8px 14px;

  border-radius: 9999px;
  background: rgba(28, 28, 36, 0.92);
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;

  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.28);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  pointer-events: none;
}

.offline-pill__icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  opacity: 0.9;
}

.offline-pop-enter-active,
.offline-pop-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.offline-pop-enter-from,
.offline-pop-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(12px);
}
</style>
